export default __webpack_public_path__ + "static/media/favorite.b6d2b314.svg";